angular.module('SpidApp')

.factory('ReceiptPDFBuilder', ['Cart',function (Cart) {
    var ReceiptPDFBuilder = {
        generateMock: function () {
            var localCurrencySymbol = '$';

            var sales = [
                  { label: 'produit  1', localPrice: 10000.00, price: 10000.00, quantity:   1 }
                , { label: 'produit  2', localPrice:     1.62, price:     1.62, quantity:  15 }
                , { label: 'produit  3', localPrice:     0.62, price:     0.62, quantity: 100 }
                , { label: 'produit  4', localPrice:    45.62, price:    45.62, quantity:   1 }
                , { label: 'produit  5', localPrice:    55.62, price:    55.62, quantity:   1 }
                , { label: 'produit  6', localPrice:    65.62, price:    65.62, quantity:   1 }
                , { label: 'produit  7', localPrice:    75.62, price:    75.62, quantity:   1 }
                , { label: 'produit  8', localPrice:     1.62, price:     1.62, quantity:  15 }
                , { label: 'produit  9', localPrice:     0.62, price:     0.62, quantity: 100 }
                , { label: 'produit 10', localPrice:    45.62, price:    45.62, quantity:   1 }
                , { label: 'produit 11', localPrice:    45.62, price:    45.62, quantity:   1 }
                , { label: 'produit 12', localPrice:    55.62, price:    55.62, quantity:   1 }
                , { label: 'produit 13', localPrice:    65.62, price:    65.62, quantity:   1 }
                , { label: 'produit 14', localPrice:    75.62, price:    75.62, quantity:   1 }
                , { label: 'produit 15', localPrice:     1.62, price:     1.62, quantity:  15 }
                , { label: 'produit 16', localPrice:     0.62, price:     0.62, quantity: 100 }
                , { label: 'produit 17', localPrice:    45.62, price:    45.62, quantity:   1 }
                , { label: 'produit 18', localPrice:    55.62, price:    55.62, quantity:   1 }
                , { label: 'produit 19', localPrice:    65.62, price:    65.62, quantity:   1 }
                , { label: 'produit 20', localPrice:    75.62, price:    75.62, quantity:   1 }
                , { label: 'produit 21', localPrice:    75.62, price:    75.62, quantity:   1 }
                , { label: 'produit 22', localPrice:     1.62, price:     1.62, quantity:  15 }
                , { label: 'produit 23', localPrice:     0.62, price:     0.62, quantity: 100 }
                , { label: 'produit 24', localPrice:    45.62, price:    45.62, quantity:   1 }
                , { label: 'produit 25', localPrice:    55.62, price:    55.62, quantity:   1 }
            ];
            var receivedPrice = 999.99;
            var backPrice = 10000;

            var cart = new Cart();

            cart.balance = backPrice;
            cart.recu = receivedPrice;
            cart.sales = sales;
            
            return this.generate(cart, localCurrencySymbol)
        },
        generate: function (cart, localCurrencySymbol) {
            if (!cart || !localCurrencySymbol) {
                throw 'ReceiptPDFBuilder::generate() - Missing parameters'
            }

            var sales = cart.getContent();

            if (sales.length === 0) {
                throw 'ReceiptPDFBuilder::generate() - Empty list of sales'
            }

            var blanks = function (str, n) {
                if (str.length > n) {
                    return str
                }

                var still = n - str.length
                var res = str

                for(var i = 0 ; i < still ; i++) {
                    res = ' ' + res
                }

                return res
            }

            var marginLeft = 5

            var salesStartY = 30
            var saleSpacing = 6

            var quantityX      = 31
            var multiplySignX  = 36.5
            var pricesX        = 40

            var totalY    = salesStartY + sales.length * saleSpacing + 5
            var receivedY = totalY + 5
            var backY     = totalY + 10

            var height = (totalY + 15) > 80 ? (totalY + 25) : 80

            var ySeparator1 = 20
            var ySeparator2 = salesStartY + sales.length * saleSpacing

            var doc = new jsPDF('portrait', 'mm', [height, 80])

            doc.setFontSize(15)
            doc.setFont("helvetica")
            doc.setFontType("bold")

            doc.text(20, 15, 'SPID ESCALEO')

            doc.setFontSize(8)
            doc.setFont('helvetica')
            doc.setFontType('normal')


            var date    =  moment();
            doc.text(marginLeft,    ySeparator1+5, date.format('L'));
            for(var i = 0 ; i < sales.length ; i++) {
                var sale = sales[i]

                var yShift = salesStartY + (i * saleSpacing)

                doc.setFont('helvetica')
                doc.text(marginLeft,    yShift, (sale.label || '').substr(0, 13))

                doc.setFont('courier')
                doc.text(quantityX,     yShift, blanks(sale.quantity + '', 3))
                doc.text(multiplySignX, yShift, 'x')
                doc.text(pricesX,       yShift, blanks(((sale.type === 'Refund')?'-':'')+(+sale.price).toFixed(2), 8) + 'e' + blanks('(' + (+sale.localPrice).toFixed(2), 9) + localCurrencySymbol + ')')
            }

            var totalPrice      = cart.getTotalPrice()
            var totalLocalPrice = cart.getTotalLocalPrice()

            doc.setFont('courier')
            doc.text(pricesX, totalY,    blanks((+totalPrice).toFixed(2), 8) + 'e' + blanks('(' + (+totalLocalPrice).toFixed(2), 9) + localCurrencySymbol + ')')
            doc.text(pricesX, receivedY, '         ' + blanks((+cart.recu).toFixed(2), 9) + localCurrencySymbol)
            doc.text(pricesX, backY,     '         ' + blanks((+cart.balance).toFixed(2)    , 9) + localCurrencySymbol)

            doc.line(20, ySeparator1, 60, ySeparator1)
            doc.line(20, ySeparator2, 60, ySeparator2)

            doc.setFont('helvetica')
            doc.setFontType('bold')
            doc.text(marginLeft, totalY, 'Total')
            doc.text(marginLeft, receivedY, 'Recu')
            doc.text(marginLeft, backY, 'Rendu')

            return doc.output('datauristring')
        }
    }
    
    return ReceiptPDFBuilder
}])
